import { FilterNames } from './useCreateFilterObject';
export const filters = [
    {
        title: 'filters.duotone.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14ccb4ed37941.png',
        options: [
            {
                title: 'filters.duotone.desert',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.117775 },
                ],
                value: 'desert',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e785662150ef3.jpeg',
            },
            {
                title: 'filters.duotone.peach',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.POLAROID, value: true },
                    // { name: FilterNames.BRIGHTNESS, value: -0.305983 },
                    { name: FilterNames.SATURATION, value: 0.164537 },
                    { name: FilterNames.VIBRANCE, value: 0.584084 },
                    { name: FilterNames.HUE, value: 1.15 },
                ],
                value: 'peach',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045200d14c4100d378f8.jpeg',
            },
            {
                title: 'filters.duotone.clash',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.KODACHROME, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.305983 },
                    { name: FilterNames.SATURATION, value: 0.062591 },
                    { name: FilterNames.VIBRANCE, value: 0.99971 },
                    { name: FilterNames.HUE, value: -0.166 },
                ],
                value: 'clash',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e7847db150ef1.jpeg',
            },
            {
                title: 'filters.duotone.plum',
                filters: [
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.207958 },
                    { name: FilterNames.SATURATION, value: -0.41185 },
                    { name: FilterNames.VIBRANCE, value: 0.325298 },
                    { name: FilterNames.HUE, value: 1.082 },
                ],
                value: 'plum',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b4bc9c1867a9.jpeg',
            },
            {
                title: 'filters.duotone.breezy',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.KODACHROME, value: true },
                    { name: FilterNames.BRIGHTNESS, value: 0.007697 },
                    { name: FilterNames.SATURATION, value: 0.344903 },
                    { name: FilterNames.VIBRANCE, value: -0.027592 },
                    { name: FilterNames.HUE, value: 1.902 },
                ],
                value: 'breezy',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e78ee5f150ef4.jpeg',
            },
            {
                title: 'filters.duotone.deepBlue',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: 0.125327 },
                    { name: FilterNames.SATURATION, value: 0.141011 },
                    { name: FilterNames.VIBRANCE, value: 0.540953 },
                    { name: FilterNames.HUE, value: 1.048 },
                ],
                value: 'deepBlue',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045200d14c969bd378f7.jpeg',
            },
            {
                title: 'filters.duotone.frog',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.082486 },
                    { name: FilterNames.SATURATION, value: 0.99971 },
                    { name: FilterNames.VIBRANCE, value: -0.576532 },
                    { name: FilterNames.HUE, value: -1.606 },
                ],
                value: 'frog',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045200d14c0fcbd378f5.jpeg',
            },
            {
                title: 'filters.duotone.sunset',
                filters: [
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.TECHNICOLOR, value: true },
                    { name: FilterNames.KODACHROME, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.027592 },
                    { name: FilterNames.SATURATION, value: 0.591926 },
                    { name: FilterNames.VIBRANCE, value: -0.329509 },
                    { name: FilterNames.HUE, value: 0.076 },
                    {
                        name: FilterNames.GAMMA,
                        value: { red: 0.815597, blue: 2.19971, green: 1.160645 },
                    },
                ],
                value: 'sunset',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b41c2f1867b1.jpeg',
            },
        ],
    },
    {
        title: 'filters.blackAndWhite.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14c742ed37942.png',
        options: [
            // {
            //   title: 'filters.blackAndWhite.ad',
            //   filters: [
            //     { name: FilterNames.BROWNIE, value: true },
            //     { name: FilterNames.BLACK_WHITE, value: true },
            //     { name: FilterNames.BRIGHTNESS, value: -0.047197 },
            //     { name: FilterNames.SATURATION, value: 0.042986 },
            //   ],
            //   value: 'ad',
            // },
            {
                title: 'filters.blackAndWhite.greyed',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.BLACK_WHITE, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.047197 },
                    { name: FilterNames.SATURATION, value: 0.042986 },
                ],
                value: 'greyed',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04536c5e785857150ef5.jpeg',
            },
            {
                title: 'filters.blackAndWhite.dusty',
                filters: [
                    { name: FilterNames.BROWNIE, value: true },
                    { name: FilterNames.BLACK_WHITE, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.04719 },
                    { name: FilterNames.SATURATION, value: 0.062591 },
                    { name: FilterNames.VIBRANCE, value: 0.184142 },
                ],
                value: 'dusty',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e786799150ef2.jpeg',
            },
            {
                title: 'filters.blackAndWhite.litho',
                filters: [
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.027592 },
                    { name: FilterNames.SATURATION, value: -0.894133 },
                    { name: FilterNames.HUE, value: -2 },
                ],
                value: 'litho',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0453edd4b4516f1867b3.jpeg',
            },
            {
                title: 'filters.blackAndWhite.sepia',
                filters: [
                    { name: FilterNames.KODACHROME, value: true },
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.047197 },
                    { name: FilterNames.SATURATION, value: -1 },
                ],
                value: 'sepia',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045300d14cdaeed378fb.jpeg',
            },
            {
                title: 'filters.blackAndWhite.weathered',
                filters: [
                    { name: FilterNames.SEPIA, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.133459 },
                    { name: FilterNames.SATURATION, value: -0.737293 },
                ],
                value: 'weathered',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0453edd4b4283a1867b2.jpeg',
            },
        ],
    },
    {
        title: 'filters.vintage.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14c0e13d37940.png',
        options: [
            {
                title: 'filters.vintage.polaroid',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.062881 },
                    { name: FilterNames.SATURATION, value: -0.239326 },
                ],
                value: 'polaroid',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e780f0d150eef.jpeg',
            },
            {
                title: 'filters.vintage.sunny',
                filters: [
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: 0.007697 },
                ],
                value: 'sunny',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045200d14c2285d378f3.jpeg',
            },
            {
                title: 'filters.vintage.oldTimer',
                filters: [
                    { name: FilterNames.VINTAGE, value: true },
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.047197 },
                ],
                value: 'oldTimer',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e78e165150ef0.jpeg',
            },
            // {
            //   title: 'filters.vintage.inferno',
            //   filters: [
            //     { name: FilterNames.VINTAGE, value: true },
            //     { name: FilterNames.POLAROID, value: true },
            //     { name: FilterNames.BRIGHTNESS, value: 0.007697 },
            //   ],
            //   value: 'inferno',
            // },
            {
                title: 'filters.vintage.snappy',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: 0.007697 },
                    { name: FilterNames.SATURATION, value: -0.258931 },
                    { name: FilterNames.VIBRANCE, value: 0.078275 },
                    { name: FilterNames.HUE, value: -0.09 },
                ],
                value: 'snappy',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b4073f1867ae.jpeg',
            },
        ],
    },
    // {
    //   title: 'filters.smooth.title',
    //   url: 'https://storage.googleapis.com/ghl-test/o6241QsiRwUIJHyjuhos/media/650ebb788069a71037e5b8a3.png',
    //   options: [
    //     {
    //       title: 'filters.smooth.chestnut',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: -0.047197 },
    //         { name: FilterNames.SATURATION, value: -0.29422 },
    //         { name: FilterNames.VIBRANCE, value: 0.290009 },
    //       ],
    //       value: 'chestnut',
    //     },
    //     {
    //       title: 'filters.smooth.softy',
    //       filters: [{ name: FilterNames.VIBRANCE, value: -0.486349 }],
    //       value: 'softy',
    //     },
    //     {
    //       title: 'filters.smooth.pebble',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: 0.101801 },
    //         { name: FilterNames.VIBRANCE, value: -0.153064 },
    //       ],
    //       value: 'pebble',
    //     },
    //     {
    //       title: 'filters.smooth.moss',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: 0.007697 },
    //         { name: FilterNames.VIBRANCE, value: 0.395876 },
    //       ],
    //       value: 'moss',
    //     },
    //     {
    //       title: 'filters.smooth.lemon',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: 0.09788 },
    //         { name: FilterNames.SATURATION, value: -0.364798 },
    //         { name: FilterNames.VIBRANCE, value: 0.45077 },
    //         { name: FilterNames.HUE, value: -0.056 },
    //       ],
    //       value: 'lemon',
    //     },
    //     {
    //       title: 'filters.smooth.greenGap',
    //       filters: [
    //         { name: FilterNames.BRIGHTNESS, value: -0.082486 },
    //         { name: FilterNames.SATURATION, value: -0.223642 },
    //         { name: FilterNames.VIBRANCE, value: -0.011908 },
    //       ],
    //       value: 'greenGap',
    //     },
    //   ],
    // },
    {
        title: 'filters.cold.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04736c5e78a6ab150ef8.png',
        options: [
            {
                title: 'filters.cold.colla',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.082486 },
                    { name: FilterNames.SATURATION, value: -0.541243 },
                    { name: FilterNames.VIBRANCE, value: 0.60761 },
                ],
                value: 'colla',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b441e81867af.jpeg',
            },
            {
                title: 'filters.cold.solanus',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.153064 },
                    { name: FilterNames.SATURATION, value: -0.627505 },
                    { name: FilterNames.VIBRANCE, value: 0.697793 },
                ],
                value: 'solanus',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04536c5e789b27150ef6.jpeg',
            },
            {
                title: 'filters.cold.kalmen',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.258931 },
                    { name: FilterNames.VIBRANCE, value: -0.682399 },
                ],
                value: 'kalmen',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045200d14cae5cd378f1.jpeg',
            },
            {
                title: 'filters.cold.jorah',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.29422 },
                    { name: FilterNames.SATURATION, value: -0.611821 },
                    { name: FilterNames.VIBRANCE, value: 0.290009 },
                    { name: FilterNames.HUE, value: 0.016 },
                ],
                value: 'jorah',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045300d14c1668d378fa.jpeg',
            },
            {
                title: 'filters.cold.levante',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.133459 },
                    { name: FilterNames.SATURATION, value: -0.309904 },
                    { name: FilterNames.VIBRANCE, value: -0.788266 },
                    { name: FilterNames.HUE, value: -0.056 },
                ],
                value: 'levante',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b43aa61867aa.jpeg',
            },
            {
                title: 'filters.cold.zephyr',
                filters: [
                    { name: FilterNames.POLAROID, value: true },
                    { name: FilterNames.BRIGHTNESS, value: -0.133459 },
                    { name: FilterNames.SATURATION, value: -0.047197 },
                    { name: FilterNames.VIBRANCE, value: -0.45106 },
                    { name: FilterNames.HUE, value: -0.02 },
                ],
                value: 'zephyr',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b467901867ac.jpeg',
            },
        ],
    },
    {
        title: 'filters.warm.title',
        url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e047300d14c747ad37943.png',
        options: [
            {
                title: 'filters.warm.golden',
                filters: [
                    { name: FilterNames.SATURATION, value: 0.027302 },
                    { name: FilterNames.VIBRANCE, value: 0.360587 },
                    { name: FilterNames.HUE, value: 0.086 },
                ],
                value: 'golden',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e04526c5e78dc6f150eee.jpeg',
            },
            {
                title: 'filters.warm.lowFire',
                filters: [
                    { name: FilterNames.SATURATION, value: 0.078275 },
                    { name: FilterNames.VIBRANCE, value: -0.062881 },
                ],
                value: 'lowFire',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e045200d14cde53d378f6.jpeg',
            },
            {
                title: 'filters.warm.sunrise',
                filters: [
                    { name: FilterNames.BRIGHTNESS, value: -0.09817 },
                    { name: FilterNames.SATURATION, value: 0.184142 },
                    { name: FilterNames.VIBRANCE, value: 0.042986 },
                ],
                value: 'sunrise',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b403081867a7.jpeg',
            },
            {
                title: 'filters.warm.flatBack',
                filters: [
                    { name: FilterNames.BRIGHTNESS, value: 0.062591 },
                    { name: FilterNames.SATURATION, value: 0.203747 },
                    { name: FilterNames.VIBRANCE, value: -0.047197 }
                ],
                value: 'flatBack',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b4d2bd1867ab.jpeg',
            },
            {
                title: 'filters.warm.pumpkin',
                filters: [
                    { name: FilterNames.BRIGHTNESS, value: -0.066802 },
                    { name: FilterNames.SATURATION, value: 0.203747 },
                    { name: FilterNames.VIBRANCE, value: -0.047197 },
                ],
                value: 'pumpkin',
                url: 'https://storage.googleapis.com/msgsndr/hE998piDgAGZDY1xzmFD/media/652e0452edd4b4774e1867b0.jpeg',
            },
        ],
    },
];
